// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"b4142fae","605":"b1b01b1a","725":"975902b7"}[chunkId] + ".chunk.js";
};